import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./styles.scss";
import { CapIcon, ContatosIcon, TellsTivit, TivitIcon } from "~misc/png_logos";
import ModalImage from "~components/Modal/ModalImage";
import useModalResponse from "~components/Modal/hooks/useModalResponse";
import { IconSupport } from "~misc/icons";
import { useConfigureFooter } from "~hooks/useHelpers";

const Problems = () => {

    const {
        isModalOpen,
        closeModal, 
        openModal,

    } = useModalResponse();

    const [isContactOpen, setIsContactOpen] = useState(false);

    const openContactModal = () => setIsContactOpen(prev => !prev);
    const closeContactModal = () => setIsContactOpen(false);

    useConfigureFooter({ notDeveloped: false });

  return (
    <>
      <div className="flex items-center justify-center py-5 max-w-6xl mx-auto">
        <div className="grid grid-cols-2 sm:grid-cols-3 tb:grid-cols-4 xl:grid-cols-5 gap-[2rem] justify-center">
            <Link
                to={"https://votorantim.service-now.com/vcbr?id=vcbr_home#problemModal"}
                target="_blank"
                className="group"
            >
                <div className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center `}>
                    <div className="flex justify-center">
                        <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                        <IconSupport className="text-black group-hover:text-white" />
                        </div>
                    </div>
                    <div className="text-center relative portrait:mt-5 mt-8 w-full">
                        <h2 className="text-xl font-semibold mb-2">Portal TIIA - Abertura de chamados</h2>
                    </div>
                </div>
            </Link>
            <div onClick={() => openModal()} >
                <div className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center `} >
                    <div className="flex justify-center">
                        <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                        <TivitIcon />
                        </div>
                    </div>
                    <div className="text-center relative portrait:mt-5 mt-8 w-full">
                        <h2 className="text-xl font-semibold mb-2">TIVIT - Abertura de chamados</h2>
                    </div>
                </div>
            </div>
            <Link
                to={"https://vcimentos.capworkflow.com/Pages/NewRequest.aspx?params=V29ya2Zsb3dJZD0xOTE3"}
                target="_blank"
                className="group"
            >
                <div className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center `}>
                    <div className="flex justify-center">
                        <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                        <CapIcon />
                        </div>
                    </div>
                    <div className="text-center relative portrait:mt-5 mt-8 w-full">
                        <h2 className="text-xl font-semibold mb-2">CAP - Cadastro de cliente</h2>
                    </div>
                </div>
            </Link>
            <Link
                to={"https://vcimentos.capworkflow.com/Pages/NewRequest.aspx?params=V29ya2Zsb3dJZD0yMjAw"}
                target="_blank"
                className="group"
            >
                <div className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center `}>
                    <div className="flex justify-center">
                        <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                        <CapIcon />
                        </div>
                    </div>
                    <div className="text-center relative portrait:mt-5 mt-8 w-full">
                        <h2 className="text-xl font-semibold mb-2">CAP - Projetos e Sistemas</h2>
                    </div>
                </div>
            </Link>
            <Link
                to={"https://vcimentos.capworkflow.com/Pages/NewRequest.aspx?params=V29ya2Zsb3dJZD0xNjY0"}
                target="_blank"
                className="group"
            >
                <div className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center `}>
                    <div className="flex justify-center">
                        <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                        <CapIcon />
                        </div>
                    </div>
                    <div className="text-center relative portrait:mt-5 mt-8 w-full">
                        <h2 className="text-xl font-semibold mb-2">CAP - Crédito</h2>
                    </div>
                </div>
            </Link>
            <Link
                to={"https://vcimentos.capworkflow.com/Pages/NewRequest.aspx?params=V29ya2Zsb3dJZD0xOTEw"}
                target="_blank"
                className="group"
            >
                <div className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center `}>
                    <div className="flex justify-center">
                        <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                        <CapIcon />
                        </div>
                    </div>
                    <div className="text-center relative portrait:mt-5 mt-8 w-full">
                        <h2 className="text-xl font-semibold mb-2">CAP - Preço e prazo</h2>
                    </div>
                </div>
            </Link>
            <div onClick={() => openContactModal()} >
                <div className={`bg-white shadow-lg rounded-lg p-4 sm:p-10 card-box h-full flex flex-col items-center justify-center group`} >
                    <div className="flex justify-center">
                        <div className="min-w-[80%] max-w-[100px] portrait:max-w-[60px] portrait:h-auto flex items-center justify-center text-center card-box__svg">
                            <span className="text-[50px] font-bold uppercase group-hover:text-white">GT</span>
                        </div>
                    </div>
                    <div className="text-center relative portrait:mt-5 mt-8 w-full">
                        <h2 className="text-xl font-semibold mb-2">Contatos</h2>
                    </div>
                </div>
            </div>
        </div>
      </div>

      <ModalImage  isOpen={isModalOpen}
        closeModal={closeModal}>
        <TellsTivit />
      </ModalImage>

      <ModalImage isOpen={isContactOpen} closeModal={closeContactModal} childrenClass="!max-w-[900px]">
        <ContatosIcon />
      </ModalImage>
    </>
  );
};

export default Problems;